import { useShowPriceInVat } from "hooks";
import { getPriceWithoutVat, isKeyLoopLocation } from "utils/common";

import type { DealerLocation } from "models";

export const useInterventionPrice = (location?: DealerLocation | null) => {
  const showPriceInVat = useShowPriceInVat();

  return {
    getInterventionPrice: (price: number) => {
      if (isKeyLoopLocation(location)) return 0;
      if (location && showPriceInVat) return getPriceWithoutVat(price, location);
      return price;
    }
  };
};
